'use strict';

import React from 'react';

import Title                     from '../../components/Title/Title';
import AvailabilityCalendar      from '../../components/AvailabilityCalendar/AvailabilityCalendar';
import BookingForm               from '../../components/BookingForm/BookingForm';
import Confirmation              from '../../components/Confirmation/Confirmation';
import { OnSchedUtils }          from '../../utils';
import { BookAppointment, 
         CreateAppointment,
         RescheduleAppointment } from '../../actions/appointmentActions';


const Availability = element => {
  const [state, setState] = React.useState({});
  const [bookingAppointment, setBookingAppointment] = React.useState(false);
  const [bookedAppointment, setBookedAppointment] = React.useState(null);
  const [initialAppointment, setInitialAppointment] = React.useState(null);
  const [bookingTimerMins, setBookingTimerMins] = React.useState(null);
  const [appointment, setAppointment] = React.useState(false);
  const [reschedule, setReschedule] = React.useState(false);

  const completeAppointment = appt => {
    OnSchedUtils.Loading(element, true);

    const Confirmation = (response) => {
      OnSchedUtils.Loading(element, false);
      setBookedAppointment(response);
    }
    console.log('book appt appt: ', appt)
    BookAppointment(element, appointment.id, appt)
      .then(Confirmation);
  }

  const bookAppointment = appt => {
    OnSchedUtils.Loading(element, true);
    
    if (element.options.rescheduleAppointmentId) {
      RescheduleAppointment(element, element.options.rescheduleAppointmentId, appt)
      .then(response => {
        OnSchedUtils.Loading(element, false);
        OnSchedUtils.CustomEvents(element.id, 'rescheduleConfirmation', response);
        setBookedAppointment(response);
        setReschedule(true)
      });
    }
    else {
      OnSchedUtils.Loading(element, true);

      CreateAppointment(element, appt)
        .then(response => {
          if (response.status === "IN") {
            setAppointment(response);
            setState(Object.assign(state, { appointment: response }))

            if (element.options.completeBooking === "IN") {
              setInitialAppointment(true);
              OnSchedUtils.CustomEvents(element.id, 'bookingConfirmation', response);
            }
            else {
              setBookingAppointment(true);
            }

            OnSchedUtils.Loading(element, false);
          }
          else {
            setAppointment(response);
            setState(Object.assign(state, { appointment: response }))
            setBookingAppointment(true);
            setBookedAppointment(response);

            OnSchedUtils.Loading(element, false);
          }
        })
    };
  }

  const rescheduleConfirmationMessage = element.options.confirmationMessage ? OnSchedUtils.ReplaceParameterValues(element.options.confirmationMessage, bookedAppointment) : OnSchedUtils.Internationalize(element, 'consumer_availability_booking_form_reschedule_confirmation');
  const confirmationMessage = element.options.confirmationMessage ? OnSchedUtils.ReplaceParameterValues(element.options.confirmationMessage, bookedAppointment) : OnSchedUtils.Internationalize(element, 'consumer_availability_booking_form_confirmation');

  if (initialAppointment) return null
  else if (reschedule) return (
    <Confirmation msg={rescheduleConfirmationMessage} />
  )
  else if (!bookingAppointment) return (
    <>
      <Title element={element} title={OnSchedUtils.Internationalize(element, 'consumer_availability_title')}/>
      <AvailabilityCalendar element={element} bookAppointment={bookAppointment} bookingTimerMins={bookingTimerMins} setBookingTimerMins={setBookingTimerMins} />
    </>
  )
  else if (!bookedAppointment) return (
    <>
      <Title element={element} title={OnSchedUtils.Internationalize(element, 'consumer_availability_booking_form_title')}/>
      <BookingForm element={element} onschedState={{state, setState}} appointment={appointment} setBookingAppointment={setBookingAppointment} setAppointment={setAppointment} completeAppointment={completeAppointment} bookingTimerMins={bookingTimerMins} />
    </>
  )
  else return (
    <Confirmation msg={confirmationMessage} />
  )
}

export default Availability;
